import { Popover } from "antd";
import { X } from "react-feather";
import { ButtonToggle } from "../../components";
import useLanguage from "../../hooks/language";
import { Translations } from "../../translations/types";
import "./ramqPopover.css";

export type LabType = "private" | "public";

export default function RamqPopover({
    setLabType,
    isRAMQPopoverOpen,
    setIsRAMQPopoverOpen,
    onCtaClick,
    onToggle,
}: {
    setLabType: (value: LabType) => void;
    isRAMQPopoverOpen: boolean;
    setIsRAMQPopoverOpen: (value: boolean) => void;
    onCtaClick: () => void;
    onToggle: () => void;
}): JSX.Element {
    const { translations } = useLanguage();
    return (
        <Popover
            placement="topRight"
            title={
                <RamqPopoverTitle
                    t={translations.availabilityPublicPage.ramqPopover}
                />
            }
            content={
                <RamqPopoverContent
                    t={translations}
                    onClose={() => setIsRAMQPopoverOpen(false)}
                    onChangeToPrivateLab={() => {
                        setLabType("private");
                        onCtaClick();
                        setIsRAMQPopoverOpen(false);
                    }}
                />
            }
            trigger="click"
            open={isRAMQPopoverOpen}
            onOpenChange={setIsRAMQPopoverOpen}
            overlayClassName="ramq-popover"
        >
            <ButtonToggle
                onToggle={(hasRamq) => {
                    onToggle();
                    if (!hasRamq) setIsRAMQPopoverOpen(true);
                }}
                toggleOffLabel={translations.common.no}
                toggleOnLabel={translations.common.yes}
                value={true}
            />
        </Popover>
    );
}

function RamqPopoverTitle({
    t,
}: {
    t: Translations["availabilityPublicPage"]["ramqPopover"];
}) {
    return (
        <span className="ramq-popover__title">
            {t.ramqPopoverTitlePrefix} <em>{t.ramqPopoverTitleEmphasis}</em>{" "}
            {t.ramqPopoverTitleSuffix}
        </span>
    );
}

function RamqPopoverContent({
    onClose,
    onChangeToPrivateLab,
    t,
}: {
    onClose: () => void;
    onChangeToPrivateLab: () => void;
    t: Translations;
}) {
    return (
        <div>
            <button
                onClick={onClose}
                className="ramq-popover__close"
                aria-label={t.common.close}
            >
                <X
                    width="20px"
                    height="20px"
                    aria-hidden="true"
                    focusable="false"
                />
            </button>
            <button
                onClick={onChangeToPrivateLab}
                className="ramq-popover__cta"
            >
                {t.availabilityPublicPage.ramqPopover.ramqPopoverCtaPrefix}{" "}
                <i>
                    {
                        t.availabilityPublicPage.ramqPopover
                            .ramqPopoverCtaEmphasis
                    }
                </i>
            </button>
        </div>
    );
}
